import { FedexTrackingCodeScannerHook } from './hooks/fedexTrackingCode';

const manifest = {
  name: 'fedex',
  version: '1.0.0',
  description: 'Fedex',
};

export function init() {
  FedexTrackingCodeScannerHook();
}
